import React, { Component } from 'react';
import axios from '../../axios';
import qs from 'qs';
import Alert from 'react-s-alert';
import SunEditor, {buttonList} from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import PropTypes from 'prop-types';

const maintenance = [
    { key: "1", value: "Aktif" },
    { key: "0", value: "Non Aktif" }
]


class Forms extends Component {
    constructor(props) {
        super(props)

        this.state = {
            app_version       : "",
            maintenance       : "",
            attendance              : "",
            pulang                  : "",
            admin_call                  : "",
            android_guru_app_version    : "",
            app_version_ios             : "",
            ios_guru_app_version        : "",
            school_name                 :"",
            isButtonLoading : false,
            isLoading       : false,
            ckDataE: '',
            ckData: ''
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeEditor = this.handleChangeEditor.bind(this);
    }

    handleChangeEditor(content) {
        this.setState({
            ckData: content
        });
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.type === 'checkbox' ? target.checked : target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })
    }

    handleSubmit() {

        this.setState({isButtonLoading: true})

        const url = this.props.mode === "Tambah" ? "setting/add" : "setting/edit"

        axios({
            method: 'post',
            url: url,
            data: qs.stringify(this.state.ckData)
        })
            .then(response => {

                const result = response.data;

                if (result.success) {

                    Alert.success(result.message)
                    window.location.reload()
                }
                else {

                    if (Array.isArray(result.message)) {

                        result.message.map(item => {
                            Alert.error(item)

                            return true
                        })
                    }
                    else {

                        Alert.error(result.message)
                    }

                    this.setState({ isButtonLoading: false })
                }
            })
            .catch(error => {

                console.log(error)
                this.setState({isButtonLoading: false})
                Alert.error("Gagal terhubung ke server!")
            })

    }

    loadData() {


        if (this.props.mode === "Edit") {

            this.setState({ isLoading: true })

            const params = qs.stringify({
               setName: 'formatkartu'
            });

            axios({
                method: 'post',
                url: '/setting?'+ params
            })
                .then(response => {
                    const result = response.data;
                    if (result.success) {
                        result.data.length > 0 ?(
                            this.setState({
                                ckDataE     : result.data[0].setting_value
                            })
                        ):(
                            this.setState({
                                ckDataE     : ''
                            })
                        )

                    }
                    else {
                        Alert.error(result.message)
                    }

                    this.setState({ isLoading: false })
                })
                .catch((error) => {

                    console.log(error)
                    Alert.error("Gagal terhubung ke server!")
                    this.setState({ isLoading: false })
                })
        }

    }

    componentDidMount() {

        if(localStorage.SISMART_USER_LEVEL !=='administrator'){
            this.props.history.replace("/dashboard");
        }

        this.loadData()
    }

    render() {
        return (
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-header">
                        {this.props.mode} Buat Format Kartu Pelajar
                    </div>
                    <div className="card-block">
                        {
                            this.state.isLoading ? 'Memuat Data...' : (
                                <div className="form-horizontal animated fadeIn">
                                    <div className="form-group row">
                                        <div className="col-md-6">
                                            <SunEditor
                                                name="ckData"
                                                setContents={this.state.ckDataE}
                                                showToolbar={true}
                                                enableToolbar={true}
                                                setOptions={{
                                                    height: 500,
                                                    buttonList: buttonList.complex
                                                }}
                                                onChange={this.handleChangeEditor}
                                            />

                                        </div>
                                        <div className="col-md-6">
                                            <div dangerouslySetInnerHTML={{ __html: this.state.ckData }} />

                                        </div>
                                    </div>
                                </div>

                            )
                        }
                    </div>
                    <div className="card-footer">
                        <button
                            type="button"
                            className="btn btn-md btn-primary"
                            disabled={this.state.isButtonLoading && "disabled"}
                            onClick={this.handleSubmit}
                        >
                            {this.state.isButtonLoading ? "Loading" : "Simpan"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}


export default Forms;


// WEBPACK FOOTER //
// ./src/views/Setting/FormatKartu.js